export default {
  push_notifications: {
    team_has_logged_nudge: {
      title:
        'De fleste på laget ditt har registrert sine aktiviteter allerede.',
      description: 'Tid for å registere dine?',
    },
    morning_message_engager: {
      foodWaste: {
        title: 'Utfordre deg selv',
        descriptions: {
          0: 'Matsvinnet blant norske husholdninger gikk ned 12 % mellom 2010 og 2015. Blir du med og bidrar til den gode trenden i dag?',
          1: '⅓ av all mat produsert for mennesker i verden blir i dag til matsvinn.',
          2: 'I Norge kaster vi tilsammen 385.000 tonn spiselig mat hvert år.',
          3: 'Hvis matsvinn hadde vært et eget land, hadde det vært på 3. plass over land med høyest klimagassutslipp. Kun USA og Kina ville hatt høyere utslipp.',
          4: '¼ av all maten som til sammen kastes i USA og Europa hvert år ville vært nok til å mette alle de 821 millioner menneskene som sulter.',
          5: 'Maten som kastes i Norge hvert år hadde vært nok til å mette minst 800.000 flere mennesker hvert år.',
          6: 'Utslippene fra matsvinnet i Norge tilsvarer utslippene fra 400.000 bensinbiler i året.',
          7: 'De 53 familiene som til nå har deltatt i MatVinn har i gjennomsnitt redusert matsvinnet sitt med 60 % i løpet av måneden de var med. Mange kuttet over 80 %. Klarer dere det samme eller bedre?',
          8: 'Maten vi kaster i Norge hvert år har en verdi på 22 milliarder kroner.',
          9: 'Det flest nordmenn oppgir som årsak til at de kaster mat er at det har «gått ut på dato». Vet du hvordan du kan stole på sansene dine?',
          10: 'Hver nordmann kaster i gjennomsnitt 42,6 kg mat hvert år.',
          11: 'Maten vi nordmenn kaster aller mest av er… restemat! 13 kg rester per person går i søpla fra gryter, tallerkener og restebokser hvert år.',
          12: 'Verden bruker landområder større enn hele Kina på å dyrke mat som kastes.',
          13: 'Matsvinn står for ca 10 prosent av alle menneskeskapte klimagassutslipp.',
          14: 'Norge forpliktet seg til FNs bærekraftsmål nr.12.3, som sier at vi skal halvere mengden mat som kastes innen 2030. Er du med også?',
          15: 'Norske butikker kaster 60.000 bananer hver dag. Én grunn er at vi ikke velger bananene som ligger igjen alene, selv om vi kun skal ha en. Gi en singel banan en sjanse i dag!',
          16: 'Hver nordmann forbruker i snitt ca. 4 400 liter vann daglig på mat. Det kreves over 3000 liter vann for å produsere en biff på 200 gram. God motivasjon for å ikke kaste den?',
          17: 'Maten som kastes i rike land (222 millioner tonn) er omtrent det samme som all mat produsert i Afrika sør for Sahara (230 millioner tonn) hvert år.',
          18: 'Ifølge FN må verdens matproduksjon øke med 60 % innen 2050 for å mette det som da vil være 9 milliarder mennesker i verden.',
          19: 'Verdens matproduksjon står for omtrent 30 % av de globale klimagassutslippene.',
          20: 'Av det kartlagte matsvinnet i Norge, står vi forbruke for 58 %. Hva hver av oss gjør hjemme kan derfor sammen gi stor effekt!',
        },
      },
      sustainableFood: {
        title: 'Utfordre deg selv',
        descriptions: {
          0: 'Det kreves 22 badekar med vann for å produsere det en person spiser og drikker i Norge i løpet av én dag.',
          1: 'Maten vi kaster i Norge hvert år kunne mettet 800 000 mennesker.',
          2: 'I Norge kaster hver av oss i gjennomsnitt mat til en verdi av 2 667 kroner i året.',
          3: 'Verdens matproduksjon står for omtrent 30 % av de globale klimagassutslippene.',
          4: 'Norske egg stemples med 28 dagers holdbarhet. Oppbevares de riktig kan de holde minst et par uker lenger.',
          5: 'Ifølge FN må matproduksjonen øke med 60% innen 2050 for å mette verdens befolkning.',
          6: 'Norske helsemyndigheters offisielle kostholdsråd anbefaler nordmenn å spise maks 500g rødt kjøtt per uke.',
          7: 'Soyaen som importeres til norsk laksefôr beslaglegger landområder i Brasil tilsvarende 10 000 småbruk.',
          8: '43% av nordmenn sier de ønsker å spise mindre kjøtt av hensyn til miljø og dyrevelferd.',
          9: 'Hadde alle spist som nordmenn, ville verden trengt 67% mer jordbruksareal enn det som er tilgjengelig',
          10: '15% av de globale menneskeskapte klimagassutslippene kommer fra dyrehold.',
          11: 'Verden bruker landområder større enn Kina på å dyrke mat som kastes.',
          12: 'Et høyt kjøttforbruk gir høyere vannforbruk. Å produsere en biff på 200 g krever over 3000 liter vann.',
          13: 'Maten vi nordmenn kaster aller mest av er… restemat! 13 kg rester per person går i søpla hvert år.',
        },
      },
      mindfulCitizen: {
        title: 'Challenge yourself',
        descriptions: {
          0: 'Velkommen til omsorgsfull innbygger utfordringen! Det er på tide å bidra til ditt lokalsamfunn - la oss sette i gang!',
          1: 'Altruisme kommer fra det franske ordet autrui, som betyr "andre". Det betyr rett og slett evnen til å fokusere på noe annet enn oss selv. Altruisme er smittsomt. La oss spre det rundt oss!',
          2: 'Gode gjerninger, samme hvor små eller store, er aldri bortkastet.',
          3: 'Å være takknemlig for de små tingene i vanskelige tider vil gi deg mer motstandskraft.',
          4: 'Hvaler og flaggermus bruker ekkolokalisering. Trær bruker røtter og sopp for å opprette kontakt. Mennesker har internett. Ikke vær bekymret, du kan alltid nå ut til de du bryr deg om.',
          5: 'Fire enkle grep kan redusere spredningen av COVID-19 og andre virus: å reise mindre, å holde seg unna folkemengder, å opprettholde sosial distansering, og å vaske hendene grundig og regelmessig.',
          6: 'Takknemlighet styrker våre personlige relasjoner! Takker du en ny person i ditt liv er det større sannsynlighet for at de fortsetter å være der.',
          7: 'Ikke glem å loggføre dine omsorgsfulle aktiviteter!',
          8: 'Når du lærer noe nytt, stimuleres dine sanseoppfatninger, noe som gjør det lettere å takle utfordringer i livet.',
          9: 'Verdens helseorganisasjon anbefaler minst 75 minutter per uke med jogging eller annen aktivitet med høy intensitet.',
          10: 'Verdens helseorganisasjon anbefaler minst 2.5 timer per uke med lett gange eller annet aktivitet med modert intensitet.',
          11: 'Åtti prosent av de mest suksessfulle menneskene i verden driver med en form for mindfulness.',
          12: 'Selvrefleksjon er et viktig moment i mindfulness! Det hjelper deg fokusere på det som skjer i øyeblikket, så du kan øve på takknemlighet.',
          13: '"Vennlighet er et språk som de døve kan høre og de blinde se." Mark Twain',
          14: 'Wow! To omsorgsfulle uker er gått! I dag kan du prøve å lytte empatisk til en du er glad i.',
          15: 'Gratulerer, vel gjennomført! Fortsett å utfordre deg selv til å utøve mindfulness og omtanke hver dag.',
        },
      },
      workTransport: {
        title: 'Utfordre deg selv',
        descriptions: {
          0: 'Små handlinger hver dag gjør en stor forskjell!',
          1: '33% av verdens befolkning sykler i dag.',
          2: 'Visste du at det finnes mer enn 7000 bildelingsbiler i Norge?',
          3: 'Å bytte fra fly til tog halverer transportfotavtrykket ditt!',
          4: 'Det handler ikke om hvor mye du forurenser, men hvor mye du kan spare!',
          5: 'Alle kan bidra til å redusere CO\u2082-utslipp - hver eneste dag!',
          6: 'Det tar tid å skape nye vaner. Øvelse gjør mester!',
          7: 'Japans nye høyhastighetstog er det raskeste i verden med en maksimumsfart på 603 km/t.',
          8: 'Å reise med tog over lengre avstander er det beste for miljøet.',
          9: '100 millioner sykler produseres hvert år i verden.',
          10: 'Spar tid, miljø og penger. Velg videokonferanse!',
          11: 'Handling skaper endring!',
          12: 'Kutter du en gjennomsnittlig flytur i Europa så har det samme klimaeffekt som å være veganer i ett år!',
          13: 'Sykkel er best for kropp, sjel og miljø!',
          14: 'Det er mer klimaeffektivt å kjøre buss enn bil, hvis det er 8 passasjerer på bussen.',
          15: 'Visste du at mer enn halvparten av musklene våre er designet for å gå?',
          16: 'Det må være 4,5 personer på en trikk for at trikken skal være mer klimavennlig enn elbilen.',
          17: 'Å reise kollektivt i stedet for å kjøre bil er en av de mest klimaeffektive handlingene du kan gjøre.',
          18: 'Å samarbeide kan gjøre det enklere og morsommere å prøve ut nye klimaaktiviteter!',
          19: 'Vi trenger gode, grønne historier. La oss skape de sammen!',
          20: 'Takket være deg er verden et skritt nærmere å nå globale klimamål. Bra jobba!',
        },
      },
      co2: {
        title: 'Utfordre deg selv',
        descriptions: {
          0: 'Velkommen til Klimautfordringen. Test ut nye, bærekraftige vaner i dag!',
          1: 'Kutter du en gjennomsnittlig flytur i Europa har det samme klimaeffekt som å være veganer i ett helt år!',
          2: 'Hvor mye kan du om mat og klima? Sjekk ut quizen og se om du kan få 3/3.',
          3: 'Å gi noen et kompliment er en effektiv måte å motivere andre til å leve mer klimavennlig!',
          4: 'Ost har et utslipp på omtrent 8 KgCo\u2082e per kg. Reduser osteinntaket og kutt utslipp!',
          5: 'Visste du at å bare kutte 3 minutter av dusjtiden din kan spare 30 liter vann?',
          6: 'Wow, for en uke! Sjekk statistikken din!',
          7: 'Du kan spare mer enn 1 tonn CO\u2082e hvert år ved å bruke ren muskelkraft til jobb!',
          8: 'En biffburger har omtrent samme klimapåvirkning som 10 vegetarburgere.',
          9: 'God morgen! Er du en av de glade syklistene som sykler til jobb i dag?',
          10: 'Hva skal du gjøre i dag?',
          11: 'Å bruke 1000NOK på klær har et utslipp på 51 KgCO\u2082e - det tilsvarer 200km i en gjennomsnittlig fossilbil.',
          12: 'Glem ikke å logge dagens klimaaktiviteter!',
          13: 'Takket være deg er verden et skritt nærmere å nå globale klimamål. Bra jobba!',
          14: 'Små handlinger hver dag gjør en stor forskjell!',
          15: 'Visste du at mer enn halvparten av musklene våre er designet for å gå?',
          16: 'Bruk favorittkoppen din en gang til før du putter den i oppvaskmaskina!',
          17: 'God morgen! Er du en av de sporty syklistene som sykler til jobb i dag?',
          18: 'Det handler ikke om hvor mye du forurenser, men hvor mye du kan spare!',
          19: 'Å samarbeide kan gjøre det enklere og morsommere å prøve ut nye klimaaktiviteter!',
          20: 'Gode, grønne historier påvirker atferd mer enn statistikk alene. Del din historie i dag!',
          21: 'En tredjedel av maten som produseres blir kastet hvert år. Redd et måltid i dag!',
        },
      },
      plastic: {
        title: 'Utfordre deg selv',
        descriptions: {
          0: 'Visste du at én sigarettstump har så mye som 12.000 mikroplastenheter i filteret?',
          1: 'EU krever 50% gjenvinning av plast i 2025. Det betyr at vi må øke gjenvinningen med 40.000 tonn årlig i Norge.',
          2: 'Mer enn 15 tonn plast havner i havet hvert minutt.',
          3: 'CO\u2082 utslipp fra plastens verdikjede øker. Dette skyldes i stor grad en enorm økning i forbruket av plastartikler og spesielt engangsplast.',
          4: 'Vi puster inn mikroplast gjennom husstøv.',
          5: 'Landbruket er mikroplast-versting. Det skyldes blant annet at mikroplast brukes i gjødsel.',
          6: 'I Norge kan det meste av plastavfallet i havet spores til forbrukere og fiskeri- og havbrukssektoren.',
          7: 'En rekke engangsartikler av plast blir forbudt i EU fra 2021 og i Norge allerede fra 2020!',
          8: 'Husk å ta med handleposer til butikken',
          9: 'Visste du at kosmetikk kan inneholde like mye mikroplast som emballasjen?',
          10: 'Rundt 80% av plasten som havner i havet stammer fra aktivitet på land.',
          11: 'Lyst på en kopp kaffe? Husk å ta med en kopp hjemmefra.',
          12: 'Det produseres over 380 millioner tonn plast årlig i verden!',
          13: 'Verdens årlige plastproduksjon tilsvarer vekten til 2/3 av verdens befolkning.',
          14: 'Fossil-plast dominerer, men plasten kan også lages av biomasse.',
          15: 'Bildekk er en versting. Å la bilen stå er derfor et av de viktigste bidragene du kan gjøre for å redusere mikroplastutslipp!',
          16: 'Hvis plastproduksjon fortsetter med dagens vekst vil utslippene tilsvare 1,34 gigatonn årlig i 2030.',
          17: 'I 1999 ble det pantet 65 millioner bokser og flasker i Norge, i 2017 hadde dette økt til 1044 millioner!',
          18: 'Plast kan inneholde tungmetaller og miljøgifter som er svært skadelig.',
          19: 'Velg gjenbruksprodukter framfor engangsprodukter av plast og bidra til mindre plast på avveier!',
          20: 'Plast blir i gjennomsnitt kun brukt i 12 minutter av dets levetid.',
          21: 'Vi må endre systemene og vår egen adferd for å løse plastproblematikken.',
          22: 'I dag må du huske å logge dine aktiviteter. I morgen er det for sent.',
        },
      },
    },
  },
  snackbar: {
    deleted_user: 'Slettet bruker',
    challenge: {
      participant_joined: 'MARKDOWN:**%{name}** deltar nå på ditt lag.',
      participants_joined:
        'MARKDOWN:**%{name}** og %{smart_count} annen deltar nå på ditt lag. |||| MARKDOWN:**%{name}** og %{smart_count} andre deltar nå på ditt lag.',
      participant_logged_activity: '%{name} logget %{activity}.',
      participant_logged_activities:
        'MARKDOWN:**%{name}** logget %{activity} og %{smart_count} annen aktivitet. |||| MARKDOWN:**%{name}** logget %{activity} og %{smart_count} andre aktiviteter.',
    },
    footprint: {
      is_saved:
        'Bra jobba! Du har akkurat redusert ditt fotavtrykk. Fortsett ditt gode arbeid for verden!',
    },
    www: {
      feedback_sent: 'Beskjeden er sendt. Takk for ditt innspill!',
    },
    account: {
      is_deleted: 'Din konto er nå slettet',
      password_reset_sent:
        'Vi har sendt deg en e-post med instruksjoner for å endre passord',
    },
    daily_streak: {
      3: 'Du har spart CO\u2082e 3 dager på rad! Klimaet smiler.',
      5: 'Du har spart CO\u2082e 5 dager på rad! Knall innsats!',
      7: 'Fantastisk! Du har oppnådd en ukes-streak. Du er en klimahelt!',
      9: 'Du fortsetter! 9 dager på rad. Dette blir det nye vaner av!',
      11: 'Herlig å se din innsats! 11 dager på rad. Fortsett med dette!',
      13: '13 dager på rad med CO\u2082e sparing. Du inspirerer laget ditt!',
      15: 'Du har spart CO\u2082e 15 dager på rad! For en innsats!',
      17: 'Du har etablert gode vaner og har spart CO\u2082e 17 dager på rad. Klimaet vinner!',
      19: 'Du er en klimahelt! 19 dager sparing på rad.',
      21: 'Du har spart alle dager i hele konkurransen! Du inspirerer!',
    },
  },
};
